import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-search-order-item',
    templateUrl: './search-order-item.component.html',
    styleUrls: ['./search-order-item.component.scss']
})
export class SearchOrderItemComponent implements OnInit {
    @Input()
    order: any
    constructor() {}

    ngOnInit(): void {
    }

}
